<template>
    <div>
        <navbar :title="text"></navbar>
        <generalize></generalize>
    </div>
</template>

<script>
import generalize from '../../components/generalize'
import navbar from '../../components/Navbar'
export default {
    components:{
        navbar,
        generalize
    },
    data(){
        return{
            text:'推广',
            dataURL:'',
            firstFlag:true
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/generalize/generalize.vue